/*
 * Smooth Text step 3 demo (snippets/mogrt-demo-text.liquid), run by
 * assets/mogrt-steps-demo.js: type the words, the monitor plays them in
 * word by word from below and out again; the panel switches Animate to
 * Characters and Position Offset to the left, and the monitor plays them
 * in letter by letter from the left. As they leave, the panel goes back
 * to its first values for the next loop.
 */
(() => {
  const parts = (screen) => {
    const text = screen.querySelector('[data-mdt-text]');
    return {
      field: screen.querySelector('[data-eg-text]'),
      text,
      words: text.querySelectorAll('.mdt-word').length,
      chars: text.querySelectorAll('.mdt-char').length,
    };
  };
  // one state of the text (see assets/mogrt-demo-text.css); "in" starts
  // from the armed frame, so lay that out first
  const show = (text, state) => {
    if (state === 'in') text.getBoundingClientRect();
    state ? text.setAttribute('data-mdt', state) : text.removeAttribute('data-mdt');
  };

  window.MogrtDemos = window.MogrtDemos || {};
  window.MogrtDemos.text = {
    rest(screen) {
      const p = parts(screen);
      p.field.dataset.full = p.field.dataset.full || p.field.textContent.trim();
      p.field.textContent = p.field.dataset.full;
      p.field.classList.remove('is-typing');
      screen.setAttribute('data-live', '');
      show(p.text, null);
    },
    async pass(screen, t) {
      const p = parts(screen);
      // the starts match the CSS: 210ms a word, 70ms a letter; the way out
      // goes by word, 130ms apart
      const leave = (p.words - 1) * 130 + 700;
      // from the finished frame (the first loop), its words blur out while
      // the panel glides back to its first values
      if (!p.text.hasAttribute('data-mdt')) {
        show(p.text, 'out');
        if (!(await t.wait(leave + 300))) return false;
      }
      show(p.text, 'armed');
      if (!(await t.wait(400))) return false;
      if (!(await t.type(p.field, p.field.dataset.full, { speed: 85 }))) return false;
      // Animate: Words, from below
      show(p.text, 'in');
      if (!(await t.wait((p.words - 1) * 210 + 1100 + 900))) return false;
      show(p.text, 'out');
      if (!(await t.wait(leave + 150))) return false;
      // Position Offset to the left, Animate: Characters
      show(p.text, 'armed');
      t.live(true);
      if (!(await t.wait(1350))) return false;
      show(p.text, 'in');
      if (!(await t.wait((p.chars - 1) * 70 + 1100 + 1700))) return false;
      show(p.text, 'out');
      t.live(false);
      return t.wait(leave + 300);
    },
  };
})();
